export default __webpack_public_path__ + "static/media/148-madeira.22f349b6.svg";